var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7970)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7970",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7970)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "url(#paint0_linear_2858_7970)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3333,
    width: 14.6667,
    height: 20,
    fill: "#08379D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.33333V0H0V20Z",
    fill: "#08379D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 20H18.6666V0H9.33325V20Z",
    fill: "#FFCC50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7456 6.4135C13.8794 6.2168 14.1702 6.2195 14.3003 6.41865L14.9965 7.48436C15.1413 7.70607 14.9822 8 14.7174 8H14.7017C14.5044 8 14.3504 8.17027 14.37 8.3665L14.6366 11.0332C14.6537 11.2036 14.7971 11.3333 14.9683 11.3333H15.1963C15.2841 11.3333 15.3683 11.2987 15.4307 11.237L15.9011 10.7717C15.9644 10.7091 16 10.6237 16 10.5347V9.4714C16 9.383 15.9649 9.29821 15.9024 9.2357L15.7147 9.04804C15.5395 8.87282 15.6099 8.57447 15.845 8.49611L16.798 8.17843C17.0387 8.09822 17.2771 8.30549 17.2313 8.55495L16.7397 11.2277C16.7271 11.2964 16.6932 11.3594 16.6429 11.4077L15.4301 12.5736C15.368 12.6333 15.2852 12.6667 15.1991 12.6667H15C14.8159 12.6667 14.6667 12.8159 14.6667 13V13.6667C14.6667 13.8508 14.5174 14 14.3333 14H13.6667C13.4826 14 13.3333 13.8508 13.3333 13.6667V13C13.3333 12.8159 13.1841 12.6667 13 12.6667H12.8047C12.7163 12.6667 12.6315 12.6315 12.569 12.569L11.4047 11.4047C11.3582 11.3582 11.3264 11.2989 11.3135 11.2344L10.7793 8.56324C10.7291 8.31227 10.9688 8.1007 11.2116 8.18164L12.155 8.49611C12.3901 8.57447 12.4605 8.87282 12.2853 9.04804L12.0976 9.2357C12.0351 9.29821 12 9.383 12 9.4714V10.5347C12 10.6237 12.0356 10.7091 12.0989 10.7717L12.5693 11.237C12.6317 11.2987 12.7159 11.3333 12.8037 11.3333H13.0317C13.2029 11.3333 13.3463 11.2036 13.3633 11.0332L13.63 8.3665C13.6496 8.17027 13.4948 8 13.2976 8C13.03 8 12.8703 7.70051 13.0208 7.47921L13.7456 6.4135Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_7970",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1132C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0522A5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7970"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryBb);
export default __webpack_public_path__ + "static/media/Country=BB.62054c3c5a5ecab23fa89c84c36afe44.svg";
export { ForwardRef as ReactComponent };